(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ud-header-account"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    document.querySelectorAll('[data-ud-account][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-ud-account][open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-ud-account][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) window.location.reload();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ud-order-support"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const link = event.target.closest('[data-ud-order-chat]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  if (link.getAttribute('aria-busy') === 'true') return;
  link.setAttribute('aria-busy', 'true');
  const linkText = link.textContent;
  link.textContent = link.dataset.openingText;
  let expired = false;
  const fallback = () => {
    if (expired) return;
    expired = true;
    link.removeAttribute('aria-busy');
    link.textContent = linkText;
    window.location.assign(link.href);
  };
  const timer = setTimeout(fallback, 8000);
  try {
    await (window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise((resolve) => window.addEventListener('gorgias-widget-loaded', resolve, { once: true })));
    if (expired) return;
    const chat = window.GorgiasChat;
    if (!chat || ['open', 'setPage', 'setCurrentInput'].some((method) => typeof chat[method] !== 'function')) throw new Error('Chat unavailable');
    await chat.setPage('conversation');
    if (expired) return;
    await chat.open();
    if (expired) return;
    if (!link.dataset.orderContextPrepared) {
      await chat.setCurrentInput(link.dataset.orderMessage);
      link.dataset.orderContextPrepared = 'true';
    }
    clearTimeout(timer);
    link.removeAttribute('aria-busy');
    link.textContent = linkText;
  } catch {
    clearTimeout(timer);
    fallback();
  }
});
  } catch(e) { console.error(e); }
})();

})();
